(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["color-description"] && !Shopify.designMode) return;
  try {
    
(function () {
  var ROOT_SELECTOR = '[data-color-description]';
  var BLOCK_SELECTOR = '.color-description__block';
  var DESKTOP_QUERY = '(min-width: 768px)';
  var EASE_DURATION = {
    desktop: { lifestyle: 480, product: 500, description: 360, divider: 400, eyebrow: 300 },
    mobile: { lifestyle: 420, product: 420, description: 320, divider: 360, eyebrow: 280 }
  };

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getDuration(name) {
    return window.matchMedia(DESKTOP_QUERY).matches ? EASE_DURATION.desktop[name] : EASE_DURATION.mobile[name];
  }

  function getActiveLifestyleImage(block) {
    var selector = window.matchMedia(DESKTOP_QUERY).matches
      ? '.color-description__lifestyle-media .media__image--desktop'
      : '.color-description__lifestyle-media .media__image--mobile';
    return block.querySelector(selector);
  }

  function waitForImage(image, complete) {
    if (!image) {
      complete();
      return;
    }

    var finished = false;
    var fallbackTimer;
    function finish() {
      if (finished) return;
      finished = true;
      window.clearTimeout(fallbackTimer);
      image.removeEventListener('load', onLoad);
      image.removeEventListener('error', finish);
      image.removeEventListener('lazyloaded', finish);
      complete();
    }
    function onLoad() {
      if (!image.classList.contains('lazyload') || image.classList.contains('lazyloaded')) finish();
    }
    function decodeAndFinish() {
      if (typeof image.decode !== 'function') {
        finish();
        return;
      }
      image.decode().catch(function () {}).then(finish);
    }

    if (image.complete && image.naturalWidth > 0 && (!image.classList.contains('lazyload') || image.classList.contains('lazyloaded'))) {
      decodeAndFinish();
      return;
    }

    image.addEventListener('load', onLoad);
    image.addEventListener('error', finish);
    image.addEventListener('lazyloaded', finish);
    fallbackTimer = window.setTimeout(finish, 5000);
  }

  function animateTargets(targets, stateTarget, className, duration, willChange, done) {
    var activeTargets = targets.filter(function (target) { return Boolean(target); });
    activeTargets.forEach(function (target) {
      target.style.willChange = willChange;
    });
    window.requestAnimationFrame(function () {
      stateTarget.classList.add(className);
      window.setTimeout(function () {
        activeTargets.forEach(function (target) {
          target.style.removeProperty('will-change');
        });
        if (done) done();
      }, duration);
    });
  }

  function revealCopy(state) {
    var block = state.block;
    var description = block.querySelector('.color-description__text');
    var divider = block.querySelector('.color-description__divider');
    var eyebrow = block.querySelector('.color-description__eyebrow');

    animateTargets([description], block, 'is-description-visible', getDuration('description'), 'opacity, transform', function () {
      var dividerDuration = getDuration('divider');
      animateTargets([divider], block, 'is-divider-visible', dividerDuration, 'transform');
      window.setTimeout(function () {
        animateTargets([eyebrow], block, 'is-eyebrow-visible', getDuration('eyebrow'), 'opacity, transform');
      }, dividerDuration / 2);
    });
  }

  function revealProduct(state, showTitle) {
    if (state.productStarted) return;
    state.productStarted = true;
    var block = state.block;
    var product = block.querySelector('.color-description__product-image, .color-description__product-placeholder');
    var title = showTitle ? block.querySelector('.color-description__title') : null;

    waitForImage(product && product.tagName === 'IMG' ? product : null, function () {
      animateTargets([product, title], block, 'is-product-visible', getDuration('product'), 'opacity, transform', function () {
        revealCopy(state);
      });
    });
  }

  function setupRoot(root) {
    if (root.dataset.colorDescriptionMotionInitialized === 'true' || prefersReducedMotion()) return;
    root.dataset.colorDescriptionMotionInitialized = 'true';
    root.classList.add('color-description--motion-ready');

    var states = Array.prototype.map.call(root.querySelectorAll(BLOCK_SELECTOR), function (block) {
      return { block: block, productStarted: false };
    });
    if (!states.length) return;

    var lifestyleObserver;

    lifestyleObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        lifestyleObserver.unobserve(entry.target);
        var state = states.find(function (item) { return item.block === entry.target; });
        if (!state) return;
        var lifestyleImage = getActiveLifestyleImage(state.block);
        waitForImage(lifestyleImage, function () {
          animateTargets([lifestyleImage || state.block], state.block, 'is-lifestyle-visible', getDuration('lifestyle'), 'opacity', function () {
            revealProduct(state, window.matchMedia(DESKTOP_QUERY).matches);
          });
        });
      });
    }, { threshold: 0.15 });

    states.forEach(function (state) {
      lifestyleObserver.observe(state.block);
    });
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll(ROOT_SELECTOR);
    Array.prototype.forEach.call(roots, setupRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m1-product-information"] && !Shopify.designMode) return;
  try {
    
(function () {
  var ROOT_SELECTOR = '[data-m1-product-information]';
  var DURATION = 240;

  function clearAnimation(panel) {
    if (panel._m1ProductInformationTransitionEnd) {
      panel.removeEventListener('transitionend', panel._m1ProductInformationTransitionEnd);
      panel._m1ProductInformationTransitionEnd = null;
    }
    if (panel._m1ProductInformationRaf) {
      window.cancelAnimationFrame(panel._m1ProductInformationRaf);
      panel._m1ProductInformationRaf = null;
    }
  }

  function finish(panel, expanded) {
    clearAnimation(panel);
    panel.hidden = !expanded;
    panel.style.height = '';
    panel.style.opacity = '';
  }

  function setExpanded(toggle, panel, expanded, immediate) {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');

    if (immediate || reduceMotion) {
      finish(panel, expanded);
      return;
    }

    clearAnimation(panel);

    if (expanded) {
      panel.hidden = false;
      panel.style.height = '0px';
      panel.style.opacity = '0';
      void panel.offsetHeight;
      panel._m1ProductInformationTransitionEnd = function (event) {
        if (event.target === panel && event.propertyName === 'height') finish(panel, true);
      };
      panel.addEventListener('transitionend', panel._m1ProductInformationTransitionEnd);
      panel._m1ProductInformationRaf = window.requestAnimationFrame(function () {
        panel.style.height = panel.scrollHeight + 'px';
        panel.style.opacity = '1';
      });
      return;
    }

    panel.style.height = panel.getBoundingClientRect().height + 'px';
    panel.style.opacity = '1';
    void panel.offsetHeight;
    panel._m1ProductInformationTransitionEnd = function (event) {
      if (event.target === panel && event.propertyName === 'height') finish(panel, false);
    };
    panel.addEventListener('transitionend', panel._m1ProductInformationTransitionEnd);
    panel._m1ProductInformationRaf = window.requestAnimationFrame(function () {
      panel.style.height = '0px';
      panel.style.opacity = '0';
    });
  }

  function init(root) {
    if (!root || root.dataset.m1ProductInformationInitialized === 'true') return;
    root.dataset.m1ProductInformationInitialized = 'true';

    var toggles = root.querySelectorAll('[data-m1-product-information-toggle]');
    Array.prototype.forEach.call(toggles, function (toggle) {
      var panelId = toggle.getAttribute('aria-controls');
      var panel = panelId ? root.querySelector('#' + panelId) : null;
      if (!panel) return;

      setExpanded(toggle, panel, toggle.getAttribute('aria-expanded') === 'true', true);
      toggle.addEventListener('click', function () {
        setExpanded(toggle, panel, toggle.getAttribute('aria-expanded') !== 'true', false);
      });
    });
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll(ROOT_SELECTOR);
    Array.prototype.forEach.call(roots, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m1-sticky-product-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  var BAR_ATTR = 'data-m1-sticky-bar';
  var LINK_ATTR = 'data-m1-sticky-link';
  var ANCHOR_ATTR = 'data-m1-sticky-anchor';
  var MENU_TOGGLE_ATTR = 'data-m1-sticky-menu-toggle';
  var MENU_ATTR = 'data-m1-sticky-menu';
  var COLOR_ATTR = 'data-m1-sticky-color';
  var SHOP_BUTTON_ATTR = 'data-m1-sticky-shop-button';
  var COLOR_LABEL_ATTR = 'data-m1-sticky-color-label';
  var SCROLL_TOP_ATTR = 'data-m1-sticky-scroll-top';
  var INIT_ATTR = 'data-m1-sticky-initialized';

  function getDocumentVar(name, fallback) {
    var rootValue = getComputedStyle(document.documentElement).getPropertyValue(name);
    var bodyValue = getComputedStyle(document.body).getPropertyValue(name);
    var value = parseFloat(rootValue || bodyValue);
    return isFinite(value) ? value : fallback;
  }

  function getHeaderHeight() {
    return getDocumentVar('--gsc-header-height', getDocumentVar('--header-group-height', 60));
  }

  function isMainHeaderHidden() {
    return document.documentElement.classList.contains('m1-sticky-main-header-hidden');
  }

  function getVisibleHeaderHeight() {
    return isMainHeaderHidden() ? 0 : getHeaderHeight();
  }

  function escapeSelector(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
    return String(value).replace(/"/g, '\\"');
  }

  function getTarget(id) {
    if (!id) return null;
    var escapedId = escapeSelector(id);
    var target = document.querySelector('[' + ANCHOR_ATTR + '="' + escapedId + '"]') || document.getElementById(id);
    if (target) return target;

    var sectionKey = String(id).replace(/^shopify-section-/, '');
    return document.querySelector('[id$="__' + escapeSelector(sectionKey) + '"]')
      || document.querySelector('[id$="' + escapedId + '"]');
  }

  function setShopUrl(button, url) {
    if (!button || !url) return;
    if (button.tagName.toLowerCase() === 'a') {
      button.setAttribute('href', url);
    }
  }

  function updatePageState() {
    var visibleBar = document.querySelector('[' + BAR_ATTR + '].is-visible');
    var shouldHide = document.querySelector('[' + BAR_ATTR + '].is-header-collapsed[data-m1-sticky-hide-main-header="true"]');
    document.documentElement.classList.toggle('m1-sticky-visible', Boolean(visibleBar));
    document.documentElement.classList.toggle('m1-sticky-main-header-hidden', Boolean(shouldHide));
  }

  function initBar(bar) {
    if (!bar || bar.getAttribute(INIT_ATTR) === 'true') return;
    bar.setAttribute(INIT_ATTR, 'true');

    var links = Array.prototype.slice.call(bar.querySelectorAll('[' + LINK_ATTR + ']'));
    var anchors = links.map(function (link) {
      var key = link.getAttribute(LINK_ATTR);
      return { key: key, el: getTarget(key) };
    }).filter(function (anchor) {
      return anchor.el;
    });
    var trigger = getTarget(bar.getAttribute('data-m1-sticky-trigger')) || (anchors[0] && anchors[0].el);
    var menuToggle = bar.querySelector('[' + MENU_TOGGLE_ATTR + ']');
    var menu = bar.querySelector('[' + MENU_ATTR + ']');
    var colorLabel = bar.querySelector('[' + COLOR_LABEL_ATTR + ']');
    var scrollTopButton = bar.querySelector('[' + SCROLL_TOP_ATTR + ']');
    var swatches = Array.prototype.slice.call(bar.querySelectorAll('[' + COLOR_ATTR + ']'));
    var shopButtons = Array.prototype.slice.call(bar.querySelectorAll('[' + SHOP_BUTTON_ATTR + ']'));
    var footer = document.querySelector('.footer');
    var hideMainHeaderWhenVisible = bar.getAttribute('data-m1-sticky-hide-main-header') === 'true';
    var ticking = false;

    function getAnchorOffset() {
      var topBar = bar.querySelector('.m1-sticky-product-bar__top');
      var topBarHeight = topBar ? topBar.getBoundingClientRect().height : 56;
      var extraOffset = window.matchMedia('(min-width: 768px)').matches ? 24 : 16;
      return getVisibleHeaderHeight() + topBarHeight + extraOffset;
    }

    function setState(visible, headerCollapsed) {
      bar.classList.toggle('is-visible', visible);
      bar.classList.toggle('is-header-collapsed', visible && headerCollapsed);
      bar.setAttribute('aria-hidden', String(!visible));
      if (!visible) closeMenu();
      updatePageState();
    }

    function closeMenu() {
      if (!menuToggle || !menu) return;
      menuToggle.setAttribute('aria-expanded', 'false');
      menu.classList.remove('is-open');
    }

    function setActiveLink(key) {
      links.forEach(function (link) {
        if (link.getAttribute(LINK_ATTR) === key) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    }

    function update() {
      ticking = false;
      var headerHeight = getHeaderHeight();
      var visible = false;
      var headerCollapsed = false;

      if (trigger) {
        var triggerTop = trigger.getBoundingClientRect().top;
        visible = triggerTop <= headerHeight;
      } else {
        visible = window.pageYOffset > headerHeight;
      }

      headerCollapsed = visible && hideMainHeaderWhenVisible;

      if (footer) {
        var footerRect = footer.getBoundingClientRect();
        var footerIsVisible = footerRect.top < window.innerHeight && footerRect.bottom > 0;

        if (footerIsVisible) {
          visible = false;
          headerCollapsed = false;
        }
      }

      setState(visible, headerCollapsed);

      if (!anchors.length) return;
      var anchorOffset = getAnchorOffset();
      var activeKey = anchors[0].key;
      anchors.forEach(function (anchor) {
        if (anchor.el.getBoundingClientRect().top <= anchorOffset + 12) {
          activeKey = anchor.key;
        }
      });
      setActiveLink(activeKey);
    }

    function scheduleUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    if (menuToggle && menu) {
      menuToggle.addEventListener('click', function () {
        var nextExpanded = menuToggle.getAttribute('aria-expanded') !== 'true';
        menuToggle.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
        menu.classList.toggle('is-open', nextExpanded);
      });
    }

    if (scrollTopButton) {
      scrollTopButton.addEventListener('click', function () {
        var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
        closeMenu();
      });
    }

    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var key = link.getAttribute(LINK_ATTR);
        var target = getTarget(key);
        if (!target) return;

        event.preventDefault();
        if (bar.classList.contains('is-visible') && bar.getAttribute('data-m1-sticky-hide-main-header') === 'true') {
          bar.classList.add('is-header-collapsed');
          updatePageState();
        }
        var offset = getAnchorOffset();
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: Math.max(0, top), behavior: reduceMotion ? 'auto' : 'smooth' });
        setActiveLink(key);
        closeMenu();
      });
    });

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var colorName = swatch.getAttribute('data-color-name') || '';
        var womenUrl = swatch.getAttribute('data-women-url') || '';
        var menUrl = swatch.getAttribute('data-men-url') || '';

        swatches.forEach(function (item) {
          item.setAttribute('aria-pressed', item === swatch ? 'true' : 'false');
        });

        if (colorLabel) colorLabel.textContent = colorName;
        shopButtons.forEach(function (button) {
          var gender = button.getAttribute(SHOP_BUTTON_ATTR);
          if (gender === 'women') setShopUrl(button, womenUrl);
          if (gender === 'men') setShopUrl(button, menUrl);
        });
      });
    });

    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate);
    scheduleUpdate();
  }

  function initAll(scope) {
    var bars = (scope || document).querySelectorAll('[' + BAR_ATTR + ']');
    Array.prototype.forEach.call(bars, initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function () {
    window.requestAnimationFrame(updatePageState);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-c1-sticky-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
var BAR_ATTR     = 'data-c1-sticky-bar';
var ACTIONS_ATTR = 'data-c1-sticky-mobile-actions';
var LINK_ATTR    = 'data-c1-sticky-link';
var ANCHOR_ATTR  = 'data-c1-anchor';

function getBodyVar(name, fallback) {
var v = parseFloat(getComputedStyle(document.body).getPropertyValue(name));
return isFinite(v) ? v : fallback;
}

function initBar(barEl) {
var sid       = barEl.getAttribute(BAR_ATTR);
var mobileBar = document.querySelector('[' + ACTIONS_ATTR + '="' + sid + '"]');
var links     = Array.prototype.slice.call(barEl.querySelectorAll('[' + LINK_ATTR + ']'));
if (!links.length) return;

/* Build anchor map: key → dedicated zero-height anchor div (data-c1-anchor).
Falls back to getElementById in case the section still carries the id directly. */
var anchors = links.map(function (link) {
var key = link.getAttribute(LINK_ATTR);
var el  = document.querySelector('[' + ANCHOR_ATTR + '="' + key + '"]')
|| document.getElementById(key);
return { key: key, el: el };
}).filter(function (a) { return a.el; });

if (!anchors.length) return;

/* Trigger: the anchor div that sits at the very top of the page content
(first anchor in DOM order). Bar shows once its top scrolls above the nav. */
var triggerEl = anchors[0].el;

var ticking = false;

function setStickyVisible(visible) {
barEl.classList.toggle('is-visible', visible);
barEl.setAttribute('aria-hidden', String(!visible));
if (mobileBar) {
mobileBar.classList.toggle('is-visible', visible);
mobileBar.setAttribute('aria-hidden', String(!visible));
}
}

function setActiveLink(key) {
links.forEach(function (link) {
if (link.getAttribute(LINK_ATTR) === key) {
link.setAttribute('aria-current', 'true');
} else {
link.removeAttribute('aria-current');
}
});
}

function update() {
ticking = false;
var navH         = getBodyVar('--nav-height', 64);
var anchorOffset = getBodyVar('--c1-sticky-anchor-offset', 148);

/* Show bar once the first anchor has scrolled above the nav bottom edge. */
setStickyVisible(triggerEl.getBoundingClientRect().top <= navH);

/* Active = last anchor whose top has crossed the offset line. */
var activeKey = anchors[0].key;
anchors.forEach(function (a) {
if (a.el.getBoundingClientRect().top <= anchorOffset + 12) activeKey = a.key;
});
setActiveLink(activeKey);
}

function scheduleUpdate() {
if (ticking) return;
ticking = true;
requestAnimationFrame(update);
}

links.forEach(function (link) {
link.addEventListener('click', function (e) {
var key    = link.getAttribute(LINK_ATTR);
var target = document.querySelector('[' + ANCHOR_ATTR + '="' + key + '"]')
|| document.getElementById(key);
if (!target) return;
e.preventDefault();
var offset = getBodyVar('--c1-sticky-anchor-offset', 148);
var top    = target.getBoundingClientRect().top + window.pageYOffset - offset;
var rmq    = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
window.scrollTo({ top: Math.max(0, top), behavior: rmq && rmq.matches ? 'auto' : 'smooth' });
setActiveLink(key);
});
});

window.addEventListener('scroll', scheduleUpdate, { passive: true });
window.addEventListener('resize', scheduleUpdate);
scheduleUpdate();
}

function init() {
var bars = document.querySelectorAll('[' + BAR_ATTR + ']');
Array.prototype.forEach.call(bars, initBar);
}

document.readyState === 'loading'
? document.addEventListener('DOMContentLoaded', init)
: init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-product-specs-section"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Scope by section id to support multiple instances */
  var SECTION_SELECTOR    = '[data-product-specs-section]';
  var PANEL_ANIMATION_MS  = 260;
  var panelAnimations     = typeof WeakMap !== 'undefined' ? new WeakMap() : null;

  /* ── tiny helper ── */
  function pa_get(panel)       { return panelAnimations ? panelAnimations.get(panel) : panel.__psa; }
  function pa_set(panel, val)  { if (panelAnimations) panelAnimations.set(panel, val); else panel.__psa = val; }
  function pa_del(panel)       { if (panelAnimations) panelAnimations.delete(panel); else delete panel.__psa; }

  /* ── DOM builder ── */
  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function(k) {
        var v = attrs[k];
        if (k === 'className') { node.className = v; }
        else if (k === 'text')  { node.textContent = v; }
        else if (k === 'style') {
          Object.keys(v).forEach(function(p) { node.style.setProperty(p, v[p]); });
        } else { node.setAttribute(k, String(v)); }
      });
    }
    if (Array.isArray(children)) {
      children.forEach(function(c) { if (c) node.appendChild(c); });
    }
    return node;
  }

  /* ── scale bar renderer ── */
  function renderScale(scale) {
    var tickCount  = Number(scale.tick_count  || scale.tickCount  || 4);
    var activeStep = Number(scale.active_step || scale.activeStep || 0);
    var markers    = scale.markers || [];
    if (typeof markers === 'string') {
      try { markers = JSON.parse(markers); } catch(_) { markers = markers.split(',').map(function(s){return s.trim();}); }
    }

    var slotWidth  = 100 / (tickCount + 1);
    var activeW    = slotWidth * 0.82;
    var activeS    = slotWidth * activeStep + (slotWidth - activeW) / 2;

    var root  = el('div', { className: 'product-specs-scale' });
    var label = el('p',   { className: 'product-specs-scale__label', text: scale.label || '' });
    var track = el('div', { className: 'product-specs-scale__track', 'aria-hidden': 'true' });
    var ticks = el('div', { className: 'product-specs-scale__ticks', 'aria-hidden': 'true' });

    track.style.setProperty('--product-specs-scale-start', activeS + '%');
    track.style.setProperty('--product-specs-scale-width', activeW + '%');

    for (var i = 0; i < tickCount; i++) {
      var tick = el('span', { className: 'product-specs-scale__tick' });
      tick.style.setProperty('--product-specs-scale-tick-position', (slotWidth * (i + 1)) + '%');
      ticks.appendChild(tick);
    }

    var markerRow = el('div', { className: 'product-specs-scale__markers' });
    markers.forEach(function(m) {
      markerRow.appendChild(el('span', { className: 'product-specs-scale__marker', text: m }));
    });

    root.appendChild(label);
    track.appendChild(ticks);
    root.appendChild(track);
    root.appendChild(markerRow);
    return root;
  }

  /* ── spec item renderer ── */
  function renderSpecItem(item) {
    var entry   = el('div', { className: 'product-specs-item' });
    var term    = el('dt',  { className: 'product-specs-item__label',     text: item.label || '' });
    var details = el('dd',  { className: 'product-specs-item__value-wrap' });
    var value   = el('p',   { className: 'product-specs-item__value',     text: item.value || '' });

    details.appendChild(value);
    if (item.note) {
      details.appendChild(el('p', { className: 'product-specs-item__note', text: item.note }));
    }
    entry.appendChild(term);
    entry.appendChild(details);
    return entry;
  }

  /* ── feature item renderer ── */
  function renderFeature(item) {
    return el('li', { className: 'product-specs-feature', text: item.text || item });
  }

  /* ── panel animation ── */
  function clearAnim(panel) {
    var state = pa_get(panel);
    if (!state) return;
    if (state.rafId)          window.cancelAnimationFrame(state.rafId);
    if (state.onTransitionEnd) panel.removeEventListener('transitionend', state.onTransitionEnd);
    pa_del(panel);
  }

  function finalizePanel(panel, expanded) {
    clearAnim(panel);
    panel.hidden = !expanded;
    panel.classList.toggle('is-collapsed', !expanded);
    panel.classList.remove('is-animating');
    panel.style.height  = '';
    panel.style.opacity = '';
  }

  function setPanelExpanded(toggle, panel, expanded, opts) {
    var immediate = Boolean(opts && opts.immediate);
    var reduced   = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');

    if (immediate || reduced) {
      finalizePanel(panel, expanded);
      return;
    }

    clearAnim(panel);

    if (expanded) {
      panel.hidden = false;
      panel.classList.remove('is-collapsed');
      panel.classList.add('is-animating');
      var targetH = panel.scrollHeight;
      panel.style.height  = '0px';
      panel.style.opacity = '0';
      void panel.offsetHeight;

      var onOpen = function(e) {
        if (e.target !== panel || e.propertyName !== 'height') return;
        finalizePanel(panel, true);
      };
      panel.addEventListener('transitionend', onOpen);
      var rafO = window.requestAnimationFrame(function() {
        panel.style.height  = targetH + 'px';
        panel.style.opacity = '1';
      });
      pa_set(panel, { rafId: rafO, onTransitionEnd: onOpen });
      return;
    }

    var startH = panel.getBoundingClientRect().height || panel.scrollHeight;
    panel.classList.add('is-animating');
    panel.style.height  = startH + 'px';
    panel.style.opacity = '1';
    void panel.offsetHeight;

    var onClose = function(e) {
      if (e.target !== panel || e.propertyName !== 'height') return;
      finalizePanel(panel, false);
    };
    panel.addEventListener('transitionend', onClose);
    var rafC = window.requestAnimationFrame(function() {
      panel.classList.add('is-collapsed');
      panel.style.height  = '0px';
      panel.style.opacity = '0';
    });
    pa_set(panel, { rafId: rafC, onTransitionEnd: onClose });
  }

  /* ── parse JSON from data-attribute safely ── */
  function parseDataJson(attr) {
    if (!attr) return [];
    try {
      /* Shopify escapes HTML entities in attribute values */
      var decoded = attr
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g,  "'")
        .replace(/&amp;/g,  '&')
        .replace(/&lt;/g,   '<')
        .replace(/&gt;/g,   '>');
      return JSON.parse(decoded) || [];
    } catch(e) {
      console.warn('[product-specs-section] Failed to parse data JSON:', e);
      return [];
    }
  }

  /* ── init one section element ── */
  function initSection(sectionEl) {
    var scalesMount   = sectionEl.querySelector('[data-product-specs-scales]');
    var itemsMount    = sectionEl.querySelector('[data-product-specs-items]');
    var featuresMount = sectionEl.querySelector('[data-product-specs-features]');
    var toggles       = sectionEl.querySelectorAll('[data-product-specs-toggle]');

    if (!scalesMount || !itemsMount || !featuresMount || !toggles.length) return;

    /* Render scales */
    var scales = parseDataJson(scalesMount.dataset.scales);
    if (scales.length) {
      while (scalesMount.firstChild) scalesMount.removeChild(scalesMount.firstChild);
      scales.forEach(function(s) { scalesMount.appendChild(renderScale(s)); });
    }

    /* Render spec items */
    var items = parseDataJson(itemsMount.dataset.items);
    if (items.length) {
      while (itemsMount.firstChild) itemsMount.removeChild(itemsMount.firstChild);
      items.forEach(function(item) { itemsMount.appendChild(renderSpecItem(item)); });
    }

    /* Render features */
    var features = parseDataJson(featuresMount.dataset.features);
    if (features.length) {
      while (featuresMount.firstChild) featuresMount.removeChild(featuresMount.firstChild);
      features.forEach(function(f) { featuresMount.appendChild(renderFeature(f)); });
    }

    /* Mark specs panel for 2-col layout on desktop */
    var specsPanel = sectionEl.querySelector('[data-product-specs-scales]');
    if (specsPanel) {
      var parentPanel = specsPanel.closest('[data-product-specs-panel]');
      if (parentPanel) parentPanel.classList.add('is-specs-panel');
    }

    /* Bind toggles */
    toggles.forEach(function(toggle) {
      var panelId = toggle.getAttribute('aria-controls');
      var panel   = panelId ? sectionEl.querySelector('#' + panelId) : null;
      if (!panel) return;

      panel.style.setProperty('--product-specs-panel-duration', PANEL_ANIMATION_MS + 'ms');
      var isExpanded = toggle.getAttribute('aria-expanded') !== 'false';
      setPanelExpanded(toggle, panel, isExpanded, { immediate: true });

      toggle.addEventListener('click', function() {
        var next = toggle.getAttribute('aria-expanded') !== 'true';
        setPanelExpanded(toggle, panel, next);
      });
    });
  }

  /* ── boot ── */
  function init() {
    var sections = document.querySelectorAll(SECTION_SELECTOR);
    if (!sections.length) return;
    Array.prototype.forEach.call(sections, initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
